import React, { useState } from "react";
import { userService } from "../../_services";
import { FormDialog } from "@/components/ui/form-dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AlertCircle } from "lucide-react";

/**
 * Add/Edit Referral URL Modal
 * Modernized with shadcn Dialog and Form components
 */
function Add_referal_url_pop({ 
    toggle_add_popup, 
    toggle_Edit_popup, 
    PopupTitle, 
    ButtonText, 
    URL_Id, 
    URL_Text 
}) {
    const [endPointText, setEndPointText] = useState(URL_Text || '');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleInputChange = (e) => {
        const value = e.target.value;
        const expression = /^[a-zA-Z0-9]*$/;
        
        if (value.match(expression)) {
            setEndPointText(value);
            setError('');
        }
    };

    const handleSubmit = async () => {
        // Validation
        if (userService.Check_Null_Empty(endPointText)) {
            setError('Please enter your referral text');
            return;
        }

        const testDomain = /.*[a-zA-Z]+.*/;
        if (!endPointText.match(testDomain)) {
            setError('Referral must contain at least one alphabet!');
            return;
        }

        setLoading(true);

        try {
            const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            const userId = Usermeta_Data.split(':')[0];

            const refId = ButtonText === 'Create' ? '-1' : URL_Id;
            const apidata = await userService.Save_Update_ReferralURL(refId, endPointText, userId);

            if (apidata && apidata.length > 0) {
                if (apidata[0].code !== "-1") {
                    // Success - close modal
                    if (ButtonText === 'Create') {
                        toggle_add_popup({ stopPropagation: () => {}, currentTarget: null });
                    } else {
                        toggle_Edit_popup({ stopPropagation: () => {}, currentTarget: null });
                    }
                } else {
                    setError(apidata[0].message);
                }
            } else {
                setError('Error! Please try later.');
            }
        } catch (error) {
            setError('Error! Please try later.');
            console.error('Error saving referral URL:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        if (ButtonText === 'Create') {
            toggle_add_popup({ stopPropagation: () => {}, currentTarget: null });
        } else {
            toggle_Edit_popup({ stopPropagation: () => {}, currentTarget: null });
        }
    };

    return (
        <FormDialog
            open={true}
            onOpenChange={handleClose}
            title={PopupTitle}
            description="Enter a unique referral URL text (alphanumeric only)"
            onSubmit={handleSubmit}
            onCancel={handleClose}
            submitText={ButtonText || "Save"}
            loading={loading}
            maxWidth="md"
        >
            <div className="space-y-2">
                <Label htmlFor="referralUrl">Referral URL</Label>
                <Input
                    id="referralUrl"
                    type="text"
                    value={endPointText}
                    onChange={handleInputChange}
                    placeholder="Enter referral text"
                    className={error ? "border-destructive" : ""}
                />
                {error && (
                    <p className="text-sm text-destructive flex items-center gap-1">
                        <AlertCircle className="h-3 w-3" />
                        {error}
                    </p>
                )}
            </div>
        </FormDialog>
    );
}

export default Add_referal_url_pop;

